
import { Action             } from "@/models/action";
import { ActionType         } from "@/models/action.type";
import { Logger             } from "@/util/logger";
import {PanoramaBrightnessComponent} from "@/components/panorama.brightness.component";

export class BrightnessResetAction extends Action {

  /** the panoramic controller that can actually do stuff for us */
  private _controller : PanoramaBrightnessComponent = null;

  /** standard constructor */
  constructor(controller : PanoramaBrightnessComponent) {
    super({
      key:   ActionType.BRIGHTNESS_RESET,
      type:  ActionType.BRIGHTNESS_RESET,
      label: 'Reset Brightness',
      icon:  '',
      tip:   ''
    });

    this._controller = controller;
  }

  /** fetch the panoramic controller */
  public controller(): PanoramaBrightnessComponent {

    return this._controller;
  }

  /** implement the action */
  public execute() : boolean {

    this._controller.reset();

    return true;
  }
}
